import { render, staticRenderFns } from "./CardCustom.vue?vue&type=template&id=6f8448aa&scoped=true"
import script from "./CardCustom.vue?vue&type=script&lang=js"
export * from "./CardCustom.vue?vue&type=script&lang=js"
import style0 from "./CardCustom.vue?vue&type=style&index=0&id=6f8448aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8448aa",
  null
  
)

export default component.exports